import React from "react";
import {
  Alert,
  Box,
  Card,
  CardContent,
  Chip,
  CircularProgress,
  Typography,
} from "@mui/material";
import { OpenInNew } from "@mui/icons-material";
import { Link } from "react-router-dom";
import { useGetComsBlocksQuery } from "../../../redux/comsApi";

const NAVY = "#123456";

export const LabourBlocks: React.FC = () => {
  const { data: blocks = [], isLoading } = useGetComsBlocksQuery();

  if (isLoading)
    return (
      <Box display="flex" justifyContent="center" py={8}>
        <CircularProgress />
      </Box>
    );

  return (
    <Box>
      <Typography variant="h4" fontWeight={700} gutterBottom>
        Blocks
      </Typography>

      <Alert
        severity="info"
        sx={{ mb: 3 }}
        action={
          <Link
            to="/coms/daily-site-report"
            style={{
              display: "flex",
              alignItems: "center",
              gap: 4,
              color: "inherit",
              textDecoration: "none",
              fontSize: 13,
              fontWeight: 600,
              whiteSpace: "nowrap",
            }}
          >
            Manage blocks <OpenInNew sx={{ fontSize: 14, ml: 0.5 }} />
          </Link>
        }
      >
        Blocks are shared with the Daily Site Report. Add or edit blocks there.
      </Alert>

      <Card>
        <CardContent sx={{ p: 0 }}>
          {blocks.length === 0 ? (
            <Box p={4} textAlign="center">
              <Typography color="text.secondary">
                No blocks found. Create blocks in the Daily Site Report section.
              </Typography>
            </Box>
          ) : (
            blocks.map((b, i) => (
              <Box
                key={b.id}
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                px={3}
                py={1.5}
                sx={{
                  borderBottom:
                    i < blocks.length - 1 ? "1px solid #f0f0f0" : "none",
                }}
              >
                <Box>
                  <Typography fontWeight={600} fontSize={14}>
                    {b.name}
                  </Typography>
                  {b.description && (
                    <Typography variant="caption" color="text.secondary">
                      {b.description}
                    </Typography>
                  )}
                </Box>
                <Box display="flex" gap={1} alignItems="center">
                  {b.code && (
                    <Chip
                      label={b.code}
                      size="small"
                      sx={{
                        bgcolor: `${NAVY}12`,
                        color: NAVY,
                        fontWeight: 700,
                        fontSize: 11,
                      }}
                    />
                  )}
                  {b.development && (
                    <Chip
                      label={b.development}
                      size="small"
                      variant="outlined"
                      sx={{ fontSize: 11 }}
                    />
                  )}
                </Box>
              </Box>
            ))
          )}
        </CardContent>
      </Card>
    </Box>
  );
};
